import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React, { useEffect, useState } from 'react';
import Form from './components';
import Loader from '../Run/components/Loader';
import useFormLoader from './logic/useFormLoader';
import { FormActionsContextProvider } from './context/FormContext';
var EcrionForm = React.forwardRef(
/**
 * @param {import('./types').EcrionFormProps} props
 * @param {React.Ref<import('./api/types').EcrionFormApi>} ref
 */
function (props, ref) {
  var options = props.options,
      renderOptions = props.renderOptions;
  var onSubmit = props.onSubmit,
      onLoaded = props.onLoaded,
      onUploadFile = props.onUploadFile;
  var onChanged = props.onChanged,
      onDirtyChanged = props.onDirtyChanged;
  var onFieldFocused = props.onFieldFocused,
      onPageChanged = props.onPageChanged;
  var formContent = props.formContent,
      formData = props.formData,
      readonly = props.readonly,
      formState = props.formState,
      contactId = props.contactId,
      context = props.context;

  var _useFormLoader = useFormLoader({
    formContent: formContent,
    formData: formData,
    readonly: readonly,
    formState: formState,
    contactId: contactId,
    context: context,
    options: options,
    renderOptions: renderOptions
  }),
      state = _useFormLoader.state,
      formApi = _useFormLoader.formApi;

  React.useImperativeHandle(ref, function () {
    return _objectSpread({}, formApi);
  });
  React.useEffect(function () {
    if (state.stage === 'loaded' && !state.hasVisibleInputFields) onSubmit && onSubmit();
  }, [state.stage]);
  if (state.stage !== 'loaded' || !state.hasVisibleInputFields) return React.createElement(Loader, null);
  return React.createElement("div", {
    style: {
      padding: 20,
      position: 'relative'
    }
  }, React.createElement(FormActionsContextProvider, null, React.createElement(Form, {
    renderOptions: renderOptions,
    onSubmit: onSubmit,
    onLoaded: onLoaded,
    onUploadFile: onUploadFile,
    onFieldFocused: onFieldFocused,
    onChanged: onChanged,
    onPageChanged: onPageChanged,
    onDirtyChanged: onDirtyChanged
  })));
});
EcrionForm.defaultProps = {
  renderOptions: {
    hideNavigationButtons: true
  }
};
export default EcrionForm;